@use "../../../node_modules/quill/dist/quill.snow.css";
@use "./extensions/HierarchicalNumbering.scss";
@use "./extensions/Pickers.scss";
@use "./extensions/AccentColor.scss";
@use "./extensions/Toolbar.scss";

sbb-form-field.hook-form-richtext {
  min-height: 0;
}

.ql-toolbar.ql-snow {
  border: none;
  background: linear-gradient(45deg, #eee, transparent);
}

.ql-container {
  font-size: 15px;
}

.ql-container.ql-snow {
  border: 1px dashed #ccc !important;
  height: auto;
}

.has-focus .ql-container {
  border: 1px solid #ccc !important;
}

.sbb-quill {
  text-align: left;
  width: 100%;

  &.ql-toolbar-dim {
    .ql-toolbar.ql-snow {
      transition: opacity 0.4s ease-in-out;
      opacity: 0.25;
    }

    &:hover,
    &.ql-focus {
      .ql-toolbar.ql-snow {
        transition: opacity 0.4s ease-in-out;
        opacity: 1;
      }
    }
  }

  // Hide native Quill link tooltip — replaced by RichTextLinkDialog
  .ql-tooltip {
    display: none !important;
  }

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    cursor: pointer;

    &-track {
      background: #f1f1f1;
      border-radius: 8px;
      margin-bottom: 2px;
    }

    &-thumb {
      background: #aaa;
      -webkit-border-radius: 5px;
      border-radius: 5px;

      &:hover {
        background: #555;
      }
    }
  }

  .ql-editor {
    max-height: 300px;
  }

  .ql-source-viewer {
    display: none;
    box-sizing: border-box;
    width: 100%;
    min-height: 180px;
    max-height: 300px;
    padding: 12px;
    border: 1px dashed #ccc;
    resize: vertical;
    font-family: monospace;
    font-size: 13px;
  }

  &.ql-source-mode {
    .ql-editor {
      display: none;
    }

    .ql-source-viewer {
      display: block;
    }

    .ql-source {
      color: var(--sbb-color-red);
    }
  }

  .ql-source {
    width: auto !important;
    padding: 3px 8px !important;
    font-size: 12px !important;
  }

  .quill-label {
    font-family: SBB;
    color: rgb(118, 118, 118);
    line-height: 24.5px;
    letter-spacing: 0.42px;
    font-size: 14px;
    text-align: left;
  }

  .ql-container.sbb-invalid {
    border: 1px solid var(--sbb-color-red) !important;
  }

  .ql-hidden {
    display: none;
  }

  .richtext-char-count {
    text-align: right;
    font-size: 13px;
    color: var(--sbb-color-smoke);
  }
}
